import React, { useEffect } from "react";
import BiddingScreen from "../Bidding/BiddingScreen";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { tenderSpecefic } from "../../../Redux/Slices/auctionSlice";
import BiddingConsumer from "../../../pages/TokenAccess/ConsumerGenerator/Auction/ReverseAuction/BiddingConsumer";
import BiddingGenerator from "../../../pages/TokenAccess/ConsumerGenerator/Auction/ReverseAuction/BiddingGenerator";
import AuctionPageDashboard from "../../../pages/TokenAccess/ConsumerGenerator/Auction/AuctionPageDashboard";
import { getLocalStorageData } from "../../../commons/browserStorage";

const ActiveRa = ({ type }) => {
  let localTenderId = getLocalStorageData("activetenderId");
  const role = useSelector(
    (state) => state?.persistedReducer?.user?.activeRole
  ).toLowerCase();

  const tenderAuctionId = useSelector(
    (state) => state?.auctionSlice?.activeTenderId
  );


  const dispatch = useDispatch();

  useEffect(() => {
    getAuction();
  }, []);

  useEffect(() => {}, []);

  const getAuction = () => {
    dispatch(tenderSpecefic(tenderAuctionId || localTenderId));
  };

  return (
    <>
      {role === "consumer" ? (
        <BiddingConsumer type={type} />
      ) : role === "generator" ? (
        <BiddingGenerator type={type} />
      ) : (
        <AuctionPageDashboard />
      )}
    </>
  );
};

export default ActiveRa;
